export default "__VITE_ASSET__CZCL$HBJ__"